export default function ModalParticipantes({ participantes, onFechar }) {
  return (
    <div
      onClick={onFechar}
      style={{
        position: 'fixed', inset: 0, zIndex: 1000,
        background: 'rgba(20,18,40,0.6)',
        display: 'flex', alignItems: 'flex-end', justifyContent: 'center',
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          width: '100%', maxWidth: 480,
          borderRadius: '16px 16px 0 0',
          background: 'var(--surface)',
          padding: '24px 24px 32px',
          maxHeight: '70vh', overflowY: 'auto',
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
          <h3 style={{ margin: 0, fontSize: 17, color: 'var(--navy)' }}>
            {participantes.length} {participantes.length === 1 ? 'pessoa participando' : 'pessoas participando'}
          </h3>
          <button
            onClick={onFechar}
            style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 4, color: 'var(--muted)', fontSize: 20, lineHeight: 1 }}
            aria-label="Fechar"
          >
            ×
          </button>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {participantes.map((p, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <div style={{
                width: 40, height: 40, borderRadius: '50%',
                background: 'var(--lavender-light, #f0eef8)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 20, flexShrink: 0,
              }}>
                {p.avatar_emoji}
              </div>
              <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 15, color: 'var(--text)' }}>
                {p.display_name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
